import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Mint Dripversity Drop ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Mint Dripversity Drop ")

import { useSalePhase } from "@/composables/useSalePhase";
import AppButton from "@/components/app/AppButton.vue";
import { ref } from "vue";
import NewsletterModal from "@/components/newsletter/NewsletterModal.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AppCta',
  props: ["color", "size"],
  setup(__props) {

const showNewsletterModal = ref(false);

const { isPreSale } = useSalePhase();



return (_ctx: any,_cache: any) => {
  return (_unref(isPreSale))
    ? (_openBlock(), _createBlock(AppButton, {
        key: 0,
        href: "https://foundation.app/@blockschmidt",
        size: __props.size,
        color: __props.color
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["size", "color"]))
    : (_openBlock(), _createBlock(AppButton, {
        key: 1,
        size: __props.size,
        color: __props.color,
        href: "https://foundation.app/@blockschmidt"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["size", "color"]))
}
}

})